<template>
  <div class="data-center" style="margin-top: 20px">
    <div class="data-center-content">
      <el-row :span="24" class="data-center-menu" v-loading="menuLoading" style="box-shadow:0px 5px 7px 0px rgba(217,217,217,0.5);">
        <div class="data-center-menu-tit">
          <i></i>
          常用功能
        </div>
        <div class="data_center_div" v-for="item in menuList" :key="item.id" @click="urlRouter(item.url)">
          <img :src="item.images" class="data_center_img">
        </div>
      </el-row>
      <el-row class="data-center-one" :span="24" style="background-color: #f0f2f5;">
        <div class="product_update TwoPieces">
          <div class="product_update_left" style="box-shadow:0px 5px 7px 0px rgba(217,217,217,0.5);">
            <p class="title_content">产品更新
              <span>
                <i>{{product_update_name}}</i><i>{{product_update}}&nbsp;</i> {{product_update_time}}</span>
            </p>
            <div class="product_update_list" v-loading="fullscreenLoading">
              <p v-for="item in productUpdateList" :key="item.id">
                <span class="product_detail_icon"></span>
                <span class="product_detail">{{item.shortDes}}</span>
              </p>
            </div>
            <h5>更多内容，请查看
              <router-link :to="'update-log?code='+ product_update_code" class='moreA'>更新日志</router-link>
            </h5>
          </div>
        </div>
        <div class="product_update" style="padding-right:0;width:60%;box-shadow:0px 5px 7px 0px rgba(217,217,217,0.5);">
          <div class="product_update_top">
            <div class="product_update_left">
              <p class="title_content" style="margin-bottom: 17px;">灵感文章TOP10</p>
              <el-table :data="InspirationArticle" height="325" center :show-header="headerArticle" :header-cell-style="{padding:'8px 0'}" :cell-style="{padding:'4px 0',border: 'none'}">
                <el-table-column>
                  <template slot-scope="scope">
                    <span v-if='scope.$index<3' class="headerArticle_top" style="background:#1980FF;color:#fff">{{scope.$index + 1}}</span>
                    <span v-else class="headerArticle_top">{{scope.$index + 1}}</span>
                    <a :href="scope.row.source_url" target="_blank">
                      <el-popover trigger="hover" placement="top">
                        <p>{{ scope.row.title }}</p>
                        <div slot="reference" class="name-wrapper" style="color:#606266">
                          {{ scope.row.title }}
                        </div>
                      </el-popover>
                    </a>
                  </template>
                </el-table-column>
              </el-table>
              <img src="../../assets/images/InspirationArticle.png" class="InspirationArticle_img">
            </div>
          </div>
        </div>
      </el-row>
    </div>
  </div>
</template>
<script>
import { getInspirationArticle } from '@/api/customer.js'
import { getCusTypes } from '@/api/set.js'
import { getUpdateLog, getUpdateLogDetail } from '@/api/manage-api.js'
import { Loading } from 'element-ui'
export default {
  name: 'dataCenter',
  data () {
    return {
      menuList: [
        {
          id: 1,
          images: require('../../assets/images/data-center01.png'),
          url: ''
        },
        {
          id: 2,
          images: require('../../assets/images/data-center02.png'),
          url: ''
        },
        {
          id: 3,
          images: require('../../assets/images/data-center03.png'),
          url: ''
        },
        {
          id: 4,
          images: require('../../assets/images/data-center04.png'),
          url: 'micro-page'
        },
        {
          id: 5,
          images: require('../../assets/images/data-center05.png'),
          url: 'card-ticket-module'
        },
        {
          id: 6,
          images: require('../../assets/images/data-center06.png'),
          url: 'public-number'
        },
        {
          id: 7,
          images: require('../../assets/images/data-center07.png'),
          url: 'message-list'
        },
        {
          id: 8,
          images: require('../../assets/images/data-center08.png'),
          url: 'activity-code'
        },
        {
          id: 9,
          images: require('../../assets/images/data-center09.png'),
          url: 'customer-analyse'
        },
        {
          id: 10,
          images: require('../../assets/images/data-center10.png'),
          url: 'behavior-analyse'
        }
      ],
      product_update_code: '',
      menuLoading: true,
      fullscreenLoading: true,
      InspirationArticle: [], // 灵感文章
      headerArticle: false,
      product_update_time: '',
      product_update: '',
      product_update_name: '',
      productUpdateList: [] // 更新日志列表
    }
  },
  methods: {
    urlRouter (url) {
      // 判断一下有没有权限
      const menuList = Lockr.get('menuList')
      // 先拿到后端返回的所有的路径集合
      let allPathList = []
      menuList.forEach(({ children: itemChild, path }) => {
        if (itemChild.length > 0) {
          itemChild.forEach(item => {
            const list = item.children.map(({ attributes }) => attributes.route)
            allPathList.push(...list)
          })
        } else {
          allPathList.push(path)
        }
      })
      // 遍历所有的路径,如果含有点击的url,则跳转,不含则无权限
      if (allPathList.includes(`/home/${url}`)) {
        this.$router.push({ path: url })
      } else {
        _g.toastMsg('error', '暂无权限')
      }
    },
    // 获取受众类型列表
    load () {
      getCusTypes().then((res) => {
        if (res.data.code == 200) {
          this.menuLoading = false
          this.menuList[0].url = 'audiences-manage/' + res.data.result[0].id
          this.menuList[1].url = 'audiences-group-manage/' + res.data.result[0].id
          this.menuList[2].url = 'tag-list/' + res.data.result[0].id
        }
      })
    },
    // 灵感文章
    getInspirationArticle () {
      getInspirationArticle().then(res => {
        if (res.data.code === 0) {
          this.InspirationArticle = res.data.data
        } else {
          // console.log(res.data.error)
        }
      })
    },
    // 产品更新（更新日志）
    getUpdateLog () {
      let that = this
      getUpdateLog().then(res => {
        let result = res.data.result.list[0]
        let list = res.data.result.list
        let ind = 0
        for(var i=0;i<list.length;i++) {
          let isHas = that.getIsHasShow(list[i].sysCode)
          if(isHas) {
            // console.log(i, list[i].sysCode, '最新且有权限')
            ind = i
            break
          }
        }
        result = list[ind]
        this.product_update_time = result.versionUpdateDateStr.substring(0, 10)
        this.product_update = result.versionCode
        this.product_update_name = result.sysName
        this.product_update_code = result.sysCode
        let id = result.id
        // 获取产品更新详情
        getUpdateLogDetail(result.id).then(res => {
          if (res.data.success) {
            this.fullscreenLoading = false
            let resDetail = res.data.result.versionUpdateDetailModelList
            if (resDetail.length >= 10) {
              for (var i = 0; i < 10; i++) {
                this.productUpdateList.push(resDetail[i])
              }
            } else {
              this.productUpdateList = resDetail
            }
          }
        })
      })
    },
    // 判断是否有权限
    getIsHasShow(code) {
      let arr = [{
        name: '智盈',
        perms: 'ZY_INTELLIQUOR'
      }]
      let subSystems = arr.concat(Lockr.get('subSystems'))
      let ind = -1
      subSystems.map(function(item, index){
        // console.log(item.perms, code)
        if(item.perms === code) {
          ind = index
        }
      })
      if(ind === -1){
        return false
      } else {
        return true
      }
    },
  },
  mounted () {
  },
  created () {
    this.getUpdateLog()
    this.getInspirationArticle()
    this.load()
  },
  beforeCreate () {

  },
  components: {
  }
}
</script>

<style scoped>
.data-center-menu {
  background: #fff;
  /*margin-bottom: 28px;*/
  margin: 0 24px 28px;
  padding: 0 50px 20px;
  box-sizing: border-box;
}
.data-center-menu-tit i {
  background: #1980ff;
  height: 26px;
  width: 6px;
  margin-bottom: -3px;
  display: inline-block;
  margin-left: -34px;
  margin-right: 10px;
}
.data-center-menu-tit {
  text-align: left;
  font-size: 22px;
  color: #333;
  padding: 27px 0 10px;
  font-weight: 600;
}
.data_center_div {
  width: 20%;
  float: left;
  padding-right: 10px;
  box-sizing: border-box;
  cursor: pointer;
}
.data_center_img {
  width: 100%;
}

.product_update {
  width: 40%;
  height: 408px;
  float: left;
  display: inline-block;
  box-sizing: border-box;
  position: relative;
  padding-right: 25px;
  /*margin-bottom: 20px;*/
}
.InspirationArticle_img {
  position: absolute;
  width: 134px;
  bottom: 35px;
  right: 127px;
}

.headerArticle_top {
  display: inline-block;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  line-height: 21px;
  margin-top: 2px;
  text-align: center;
  float: left;
  margin-right: 8px;
}
.product_update_list span.product_detail {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  float: left !important;
  width: calc(100% - 12px);
  margin-right: 0;
  color: #606266;
  padding-left: 2px;
  min-height: 24px;
  font-size: 12px;
}
/*屏幕小于1450*/
/*@media screen and (max-width: 1320px) {
  .product_update{
    width: 50% !important;
  }
  .chart1-content{
    width: 50% !important;
  }
  .ThreePieces{
    height: 390px !important;
    padding-right: 20px !important;
  }
  .ThreePieces .chart1{
    height: 340px !important;
  }
  .TwoPieces{
    padding-right: 0 !important;
  }
  .hotSaleSmal{
    display: block !important;
  }
  .hotSaleBig{
    display: none !important;
  }
  .el-form-item{
    margin-bottom: 0;
  }
  .el-table__expanded-cell{
    padding: 7px 30px;
  }
}*/
.hotSaleSmal {
  display: none;
}
.hotSaleSmal label {
  width: 90px;
}
.hotSaleSmal .el-form-item {
  min-width: 100%;
  margin-right: 0;
  width: auto;
  text-align: left;
}
.data-center-one .ThreePieces {
  padding-right: 0;
}
.product_update_left {
  width: 100%;
  height: 100%;
  position: relative;
  background: #fff;
}
.product_update h5 {
  position: absolute;
  right: 30px;
  bottom: 10px;
  color: #333;
  margin-bottom: 10px;
}
.product_update p > span i {
  font-style: normal;
  margin-right: 5px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}
.product_update p > span {
  color: #999999;
  float: right;
  margin-right: 15px;
  font-size: 14px;
}
.product_update_list {
  height: 295px;
  padding: 10px 28px 0 28px;
  position: relative;
  overflow: auto;
}
.product_update_list p {
  margin: 0;
  padding: 0;
  line-height: 24px;
  position: relative;
  font-size: 14px;
  text-align: left;
  width: 100%;
  height: 24px;
}
.product_update_list p .product_detail_icon {
  display: inline-block;
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background: #1980ff;
  float: left;
  margin-right: 5px;
  box-shadow: 0px 0px 3px #1061c7;
  margin-top: 9px;
}
.product_update .moreA {
  color: #1980ff;
}
.product_update_top {
  width: 100%;
  height: 408px;
  box-sizing: border-box;
}
.top_table {
  width: 100%;
  height: 270px;
}

.data-center {
}
.data-center-one {
  margin-left: 24px;
  margin-right: 24px;
}
.chart1 {
  width: 100%;
  height: 230px;
  background: #fff;
}
.chart3 {
  height: 350px;
  background: #fff;
}
#mapContainer {
  width: calc(100% + 1px);
}
.chart1-content {
  float: left;
  width: 33%;
  height: 280px;
  padding-right: 20px;
  box-sizing: border-box;
  background: #f0f2f5;
  margin-bottom: 20px;
  /*padding: 10px 10px 10px 10px;*/
}
.chart3-content {
  float: left;
  width: 33%;
}
p.title_content {
  text-align: left;
  height: 66px;
  margin: 0;
  background: #fff;
  border-bottom: 1px solid #ebebeb;
  line-height: 66px;
  padding-left: 15px;
  box-sizing: border-box;
  color: #333333;
  font-weight: 600;
  font-size: 22px;
}
.data-center-add {
  float: left;
  width: 50%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: column;
}
.wechat-follow {
  float: left;
  width: 33%;
  background: #fff;
  box-sizing: border-box;
}
.hot-sale-content {
  float: left;
  width: 33%;
  background: #fff;
  height: 500px;
  box-sizing: border-box;
}
.data-center-add-input {
  width: 86px;
  float: right;
}
.customer-count {
  padding-top: 10px;
  width: 100%;
  height: 40px;
  background: #fff;
}
.customer-count p {
  width: 100%;
  background: #fff;
  text-align: center;
  font-size: 22px;
  font-weight: 500;
  margin: 0px 10px 0px 0px;
}
.data-center-two {
  width: 100%;
  padding-left: 10px;
  background: #fff;
  margin-top: 10px;
}
.data-center-two p {
  text-align: left;
  margin-bottom: 10px;
  margin-top: 10px;
}
.wechat-follow p {
  text-align: left;
  float: left;
  color: #333;
  /*width: 150px;*/
  font-weight: bold;
  font-size: 14px;
  margin-top: 10px;
  margin-left: 18px;
}
.current-follow p {
  width: 100%;
  text-align: center;
  font-size: 40px;
  font-weight: 500;
  color: #485157;
  margin: 0px 10px 0px 0px;
}
.cancel-follow p {
  width: 100%;
  text-align: center;
  font-size: 40px;
  font-weight: 500;
  margin: 0px 10px 0px 0px;
  color: #7fd1a0;
}
.today-follow {
  width: 71%;
  height: 150px;
  margin: 80px auto 40px;
  line-height: 150px;
  box-shadow: 0px 0px 14px #e0e9f4;
  background: url(../../assets/images/wx_follow_bg3.png) no-repeat;
  background-size: 100% 100%;
}
.today-follow1 {
  background: url(../../assets/images/wx_follow_bg1.png) no-repeat;
  background-size: 100% 100%;
}
.today-follow2 {
  background: url(../../assets/images/wx_follow_bg2.png) no-repeat;
  background-size: 100% 100%;
}
.today-follow p {
  width: 100%;
  text-align: center;
  font-size: 32px;
  font-weight: 500;
  margin: 0px 10px 0px 0px;
  color: #ffffff;
}
.today-follow p img {
  height: 35px;
  vertical-align: baseline;
}
.wechat-follow-select {
  float: right;
  width: 111px;
}
.wechat-follow-select .el-input__inner {
  border: none;
}
.chart6-content {
  width: 67%;
  height: 500px;
  padding-right: 20px;
  box-sizing: border-box;
  float: left;
}
.customer-distribute {
  width: 400px;
}
.data-el-menu {
  float: right;
  width: 320px;
  margin-left: 10px;
  margin-top: 10px;
}
.data-center-select {
  float: right;
  margin-top: 5px;
  margin-right: 20px;
  margin-left: 10px;
  width: 250px !important;
}
.public-number-select {
  float: right;
  margin-top: 20px;
  margin-right: 30px;
  width: 120px;
}
.trigger-event-select {
  float: right;
  margin-top: 20px;
  margin-right: 80px;
  width: 170px;
}
.order-calendar {
  margin-top: 5px;
  /*width: 200px;*/
  height: 50px;
  float: right;
}
.customer-value {
  width: 500px;
  height: 30px;
  float: right;
}
.order-calendar ul,
.customer-value ul {
  display: inline-block;
  float: right;
  margin: 0;
  margin-right: 10px;
  padding: 0;
}
.order-calendar ul li,
.customer-value ul li {
  float: left;
  width: auto;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  padding: 0 7px;
  display: inline-block;
  margin-top: 0px;
  font-size: 14px;
}
.order-calendar ul li.active,
.customer-value ul li.active {
  color: #1890ff;
  /*border-bottom: 1px solid #1890FF;*/
}
.data-center-add-customer {
  background: #fff;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.data-center-add-customer p {
  width: 100%;
  margin-top: 0px;
  text-align: center;
  color: #666;
}
.add-customer-one {
  width: 100%;
}
.add-customer-one p {
  float: left;
  font-weight: bold;
  margin-bottom: 0px;
  text-align: left;
  color: #333;
}
.add-customer-two {
  width: 100%;
  height: 64%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  height: 64%;
  box-sizing: border-box;
  flex-direction: column;
}
.add-customer-count {
  width: 100%;
  text-align: center;
  font-size: 40px;
  color: #333;
}
.add-customer-count-text {
  width: 100%;
  text-align: center;
  margin-right: 5px;
  font-size: 40px;
  color: #333;
}
.add-customer-percent {
  color: #fc5167;
  width: auto;
  text-align: center;
  margin-left: 5px;
}
.add-customer-percent span {
  display: block;
  color: #333;
  padding-right: 10px;
  padding-left: 10px;
  line-height: 20px;
  height: 20px;
  font-size: 18px;
  text-align: center;
  border-radius: 10px;
  margin-top: 15px;
}
.add-customer-percent img {
  width: 15px;
  height: 15px;
  line-height: 20px;
}
.add-customer-percent-text {
  color: #7fd1a0;
  width: auto;
  text-align: center;
}
.add-customer-percent-text span {
  display: block;
  color: #4ecf2c;
  padding-right: 10px;
  padding-left: 10px;
  line-height: 20px;
  height: 20px;
  font-size: 18px;
  text-align: center;
  border-radius: 10px;
  margin-top: 15px;
  vertical-align: center;
}
.add-customer-percent-text img {
  width: 15px;
  height: 15px;
  line-height: 20px;
}
.order-total {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  background-color: #fff;
  padding-bottom: 20px;
}
.chart6 {
  width: 106%;
  height: 100%;
}
.chart6-content-one {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #ebebeb;
}
.chart6-content-zero {
  width: 100%;
  height: 30px;
}
.chart6-content-zero p {
  text-align: left;
  padding-left: 20px;
  margin-bottom: 0px;
  border-bottom: 1px solid #dedede;
  padding-bottom: 10px;
}
.chart6-view-one {
  width: 100%;
  height: 80px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  margin-top: 20px;
}
.chart6-view {
  margin-top: 10px;
  float: left;
  width: 33%;
  height: 270px;
  padding-right: 10px;
  box-sizing: border-box;
}
.chart6-view-two {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.buy-content {
  width: 30%;
  height: 50px;
}
.total-order-count {
  width: 33%;
  height: 50px;
}
.total-order-money {
  width: 33%;
  height: 50px;
}
.total-order-money p,
.total-order-count p,
.buy-content p {
  margin-left: 40px;
}
.buy-content p:first-child,
.total-order-count p:first-child,
.total-order-money p:first-child {
  text-align: left;
  color: #666;
  font-size: 14px;
  margin-top: 0px;
  margin-bottom: 5px;
}
.buy-content p:last-child,
.total-order-count p:last-child,
.total-order-money p:last-child {
  text-align: left;
  color: #333;
  font-size: 28px;
  font-weight: 400;
  margin-top: 5px;
}
.el-menu-item .menu-btn {
  display: none;
  float: right;
}
.el-menu-item:hover .menu-btn {
  display: block;
}
.name-wrapper {
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
  cursor: pointer;
}
.line-div {
  margin-top: 15px;
  margin-left: 5px;
  margin-right: 7px;
  height: 15px;
  width: 3px;
  background-color: #1890FF;
  float: left;
}
.el-scrollbar {
  overflow-y: auto;
}
</style>
